<template>
  <div class="center">
    <grid-loader v-if="show" :color="color" :size="size"></grid-loader>
  </div>
</template>

<script>
import GridLoader from "vue-spinner/src/GridLoader.vue";
export default {
    name: "Loading",
    components:{
      GridLoader
    },
    props: {
        mySize: {
            default: 'middle'
        }
    },
    data() {
        return {
            color: '#6699cc',
            size:'20px',
            show:false
        }
    },
    mounted() {
        switch(this.mySize) {
            case 'big':
                this.size = '30px';
                break;
            case 'middle':
                this.size = '20px';
                break;
            case 'small':
                this.size = '10px';
                break;
            default:
                this.size = '30px';
        }
        this.show = true;
    }
}
</script>
<style scoped>
.center {
  margin: 0;
  position: absolute;
  top: 50%;
  left: 50%;
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}
</style>



// WEBPACK FOOTER //
// src/views/common/blockLoading.vue